export const COMPANIES_LIST = [
  {
    name: 'Gjensidige',
    nickName: 'GJENSIDIGE'
  },
  {
    name: 'If',
    nickName: 'IF'
  },
  {
    name: 'SpareBank 1',
    nickName: 'SPAREBANK_1'
  },
  {
    name: 'Tryg',
    nickName: 'TRYG'
  },
  {
    name: 'DNB',
    nickName: 'DNB'
  },
  {
    name: 'Eika',
    nickName: 'EIKA'
  },
  {
    name: 'Storebrand',
    nickName: 'STOREBRAND'
  },
  {
    name: 'Undefined',
    nickName: 'UNDEFINED'
  }
];

export const COMPANIES_NAME_LIST = {
  GJENSIDIGE: 'Gjensidige',
  IF: 'If',
  SPAREBANK_1: 'SpareBank 1',
  TRYG: 'Tryg',
  DNB: 'DNB',
  EIKA: 'Eika',
  STOREBRAND: 'Storebrand',
  UNDEFINED: 'Undefined'
};

export const GENERIC_PREVIOUS_COMPANY_MAP = {
  AGRIA: 'Agria',
  AKADEMIKERFORBUNDETS: 'Akademikerforbundets forsikringskontor',
  ALFA: 'Alfa Forsikring',
  BYGGMESTER: 'Byggmesterforsikring AS',
  COVERME: 'CoverMe',
  DIGISURE: 'Digisure Forsikring',
  EIKA_AS: 'Eika Forsikring AS',
  ENTER: 'Enter',
  EUROPEISKE: 'Europeiske',
  FENDER_MARINE: 'Fender Marine',
  FREMTIND: 'Fremtind',
  FRENDE: 'Frende Skadeforsikring',
  GJENSIDIGE: 'Gjensidige',
  GOUDA: 'Gouda',
  GRANNE: 'Granne Forsikring',
  HEDVIG: 'Hedvig Forsikring',
  IBIS: 'Ibis Forsikring',
  IF: 'If',
  JERNBANEPERSONALETS: 'Jernbanepersonalets Forsikring',
  KLP: 'KLP',
  KNIF_TRYGGHET: 'KNIF trygghet forsikring',
  KOMPLETT: 'Komplett',
  LANDBRUKS: 'Landbruksforsikring',
  LANDKREDITT: 'Landkreditt Forsikring',
  MORETRYGD: 'Møretrygd',
  NAF: 'NAF',
  OBOS: 'OBOS',
  PROTECTOR: 'Protector Forsikring',
  REAL: 'Real Forsikring',
  REIN: 'Rein forsikring',
  SAGA: 'Saga Forsikring',
  STOREBRAND: 'Storebrand',
  SUM_IT: 'Sum-IT',
  SODERBERG_AND_PARTNERE: 'Søderberg & Partnere',
  TOTEN: 'Toten Forsikring',
  TOYOTA_AIOI: 'Toyota forsikring AIOI',
  TROLL: 'Troll Forsikring',
  TRYG: 'Tryg Forsikring',
  TT: 'TT Forsikring',
  UNISON: 'Unison',
  VOLVIA: 'Volvia forsikring',
  WATERCIRCLES: 'WaterCircles',
  DNB: 'DNB',
  SPAREBANK1: 'SpareBank1',
  EIKA: 'Eika Forsikring',
  CODAN: 'Codan',
  INSR: 'INSR/NEMI',
  TIDE: 'Tide Forsikring',
  LY: 'Ly Forsikring',
  MORTGAGE: 'Møretrygd',
  KNIF: 'KNIF Trygghet Forsikring',
  ANNET: 'Annet forsikringsselskap',
  NY: 'Ny Forsikring',
  UNDEFINED: 'Undefined'
};

/**
 * Maps insuranceCompany API/crawler values to display names from GENERIC_PREVIOUS_COMPANY_MAP.
 */
export const COMPANIES_API_LIST = {
  IF_INSURANCE_V1: GENERIC_PREVIOUS_COMPANY_MAP.IF,
  IF_INSURANCE_V2: GENERIC_PREVIOUS_COMPANY_MAP.IF,
  DNB_INSURANCE: GENERIC_PREVIOUS_COMPANY_MAP.DNB,
  SPARE_BANK_INSURANCE: GENERIC_PREVIOUS_COMPANY_MAP.SPAREBANK1,
  TRYG_INSURANCE: GENERIC_PREVIOUS_COMPANY_MAP.TRYG,
  TRYG_ALL_INSURANCE: GENERIC_PREVIOUS_COMPANY_MAP.TRYG,
  GJENSIDIGE_INSURANCE: GENERIC_PREVIOUS_COMPANY_MAP.GJENSIDIGE,
  FRENDE_INSURANCE_V1: GENERIC_PREVIOUS_COMPANY_MAP.FRENDE,
  FRENDE_INSURANCE_V2: GENERIC_PREVIOUS_COMPANY_MAP.FRENDE,
  EIKA_INSURANCE: GENERIC_PREVIOUS_COMPANY_MAP.EIKA,
  FRENDE_PRODUCT_DOCUMENT_INSURANCE: GENERIC_PREVIOUS_COMPANY_MAP.FRENDE,
  STOREBRAND: GENERIC_PREVIOUS_COMPANY_MAP.STOREBRAND,
  GJENSIDIGE_B2B: GENERIC_PREVIOUS_COMPANY_MAP.GJENSIDIGE,
  undefined: GENERIC_PREVIOUS_COMPANY_MAP.UNDEFINED,
  WATERCIRCLES: GENERIC_PREVIOUS_COMPANY_MAP.WATERCIRCLES,
  FREMTIND: GENERIC_PREVIOUS_COMPANY_MAP.FREMTIND,
  JERNBANEPERSONALETS: GENERIC_PREVIOUS_COMPANY_MAP.JERNBANEPERSONALETS,
  GJENSIDIGE: GENERIC_PREVIOUS_COMPANY_MAP.GJENSIDIGE,
  IF: GENERIC_PREVIOUS_COMPANY_MAP.IF,
  DNB: GENERIC_PREVIOUS_COMPANY_MAP.DNB,
  SPAREBANK1: GENERIC_PREVIOUS_COMPANY_MAP.SPAREBANK1,
  TRYG: GENERIC_PREVIOUS_COMPANY_MAP.TRYG,
  EIKA: GENERIC_PREVIOUS_COMPANY_MAP.EIKA,
  FRENDE: GENERIC_PREVIOUS_COMPANY_MAP.FRENDE,
  KLP: GENERIC_PREVIOUS_COMPANY_MAP.KLP,
  CODAN: GENERIC_PREVIOUS_COMPANY_MAP.CODAN,
  INSR: GENERIC_PREVIOUS_COMPANY_MAP.INSR,
  TIDE: GENERIC_PREVIOUS_COMPANY_MAP.TIDE,
  KOMPLETT: GENERIC_PREVIOUS_COMPANY_MAP.KOMPLETT,
  LANDKREDITT: GENERIC_PREVIOUS_COMPANY_MAP.LANDKREDITT,
  LY: GENERIC_PREVIOUS_COMPANY_MAP.LY,
  MORTGAGE: GENERIC_PREVIOUS_COMPANY_MAP.MORTGAGE,
  KNIF: GENERIC_PREVIOUS_COMPANY_MAP.KNIF,
  ENTER: GENERIC_PREVIOUS_COMPANY_MAP.ENTER,
  ANNET: GENERIC_PREVIOUS_COMPANY_MAP.ANNET,
  NY: GENERIC_PREVIOUS_COMPANY_MAP.NY,
  AGRIA: GENERIC_PREVIOUS_COMPANY_MAP.AGRIA,
  AKADEMIKERFORBUNDETS: GENERIC_PREVIOUS_COMPANY_MAP.AKADEMIKERFORBUNDETS,
  ALFA: GENERIC_PREVIOUS_COMPANY_MAP.ALFA,
  BYGGMESTER: GENERIC_PREVIOUS_COMPANY_MAP.BYGGMESTER,
  COVERME: GENERIC_PREVIOUS_COMPANY_MAP.COVERME,
  DIGISURE: GENERIC_PREVIOUS_COMPANY_MAP.DIGISURE,
  EIKA_AS: GENERIC_PREVIOUS_COMPANY_MAP.EIKA_AS,
  EUROPEISKE: GENERIC_PREVIOUS_COMPANY_MAP.EUROPEISKE,
  FENDER_MARINE: GENERIC_PREVIOUS_COMPANY_MAP.FENDER_MARINE,
  GOUDA: GENERIC_PREVIOUS_COMPANY_MAP.GOUDA,
  GRANNE: GENERIC_PREVIOUS_COMPANY_MAP.GRANNE,
  HEDVIG: GENERIC_PREVIOUS_COMPANY_MAP.HEDVIG,
  IBIS: GENERIC_PREVIOUS_COMPANY_MAP.IBIS,
  KNIF_TRYGGHET: GENERIC_PREVIOUS_COMPANY_MAP.KNIF_TRYGGHET,
  LANDBRUKS: GENERIC_PREVIOUS_COMPANY_MAP.LANDBRUKS,
  MORETRYGD: GENERIC_PREVIOUS_COMPANY_MAP.MORETRYGD,
  NAF: GENERIC_PREVIOUS_COMPANY_MAP.NAF,
  OBOS: GENERIC_PREVIOUS_COMPANY_MAP.OBOS,
  PROTECTOR: GENERIC_PREVIOUS_COMPANY_MAP.PROTECTOR,
  REAL: GENERIC_PREVIOUS_COMPANY_MAP.REAL,
  REIN: GENERIC_PREVIOUS_COMPANY_MAP.REIN,
  SAGA: GENERIC_PREVIOUS_COMPANY_MAP.SAGA,
  SUM_IT: GENERIC_PREVIOUS_COMPANY_MAP.SUM_IT,
  SODERBERG_AND_PARTNERE: GENERIC_PREVIOUS_COMPANY_MAP.SODERBERG_AND_PARTNERE,
  TOTEN: GENERIC_PREVIOUS_COMPANY_MAP.TOTEN,
  TOYOTA_AIOI: GENERIC_PREVIOUS_COMPANY_MAP.TOYOTA_AIOI,
  TROLL: GENERIC_PREVIOUS_COMPANY_MAP.TROLL,
  TT: GENERIC_PREVIOUS_COMPANY_MAP.TT,
  UNISON: GENERIC_PREVIOUS_COMPANY_MAP.UNISON,
  VOLVIA: GENERIC_PREVIOUS_COMPANY_MAP.VOLVIA
};

export const COMPANIES_API_VALIDATION_LIST = {
  GJENSIDIGE: 'Gjensidige',
  IF: 'If',
  SPAREBANK_1: 'SpareBank 1',
  TRYG: 'Tryg',
  DNB: 'DNB',
  EIKA: 'Eika',
  FRENDE: 'Frende',
  STOREBRAND: 'Storebrand',
  KNIF: 'Knif',
  OTHER: 'Annet selskap',
  UNDEFINED: 'Undefined'
};


export const COMPANIES_USER_UI_LIST = {
  GJENSIDIGE: {
    name: 'Gjensidige',
    apiName: 'GJENSIDIGE',
    linkName: 'gjensidige'
  },
  KNIF: {
    name: 'Knif',
    apiName: 'KNIF',
    linkName: 'knif'
  },
  IF: {
    name: 'If',
    apiName: 'IF',
    linkName: 'if'
  },
  SPAREBANK_1: {
    name: 'SpareBank 1',
    apiName: 'SPAREBANK_1',
    linkName: 'sparebank-1'
  },
  TRYG: {
    name: 'Tryg',
    apiName: 'TRYG',
    linkName: 'tryg',
  },
  DNB: {
    name: 'DNB',
    apiName: 'DNB',
    linkName: 'dnb',
    disabled: true
  },
  EIKA: {
    name: 'Eika',
    apiName: 'EIKA',
    linkName: 'eika'
  },
  FRENDE: {
    name: 'Frende',
    apiName: 'FRENDE',
    linkName: 'frende',
    disabled: true
  },
  STOREBRAND: {
    name: 'Storebrand',
    apiName: 'STOREBRAND',
    linkName: 'storebrand'
  },
  OTHER: {
    name: 'Annet selskap',
    apiName: 'OTHER',
    linkName: 'other'
  }
};
